webpackJsonp([10991734084388],{

/***/ 89:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var fadeIn = exports.fadeIn = {
	  from: { opacity: 0 },
	  to: { opacity: 1 }
	};
	
	var fadeInLeft = exports.fadeInLeft = {
	  from: { x: 50, opacity: 0 },
	  to: { x: 0, opacity: 1 }
	};
	
	var fadeInUp = exports.fadeInUp = {
	  from: { y: 50, opacity: 0 },
	  to: { y: 0, opacity: 1 }
	};
	
	var fadeInRight = exports.fadeInRight = {
	  from: { x: -50, opacity: 0 },
	  to: { x: 0, opacity: 1 }
	};
	
	var scaleIn = exports.scaleIn = {
	  from: { scaleX: 0.5, opacity: 0 },
	  to: { scaleX: 1, opacity: 1 }
	};
	
	var imageLeft = exports.imageLeft = {
	  from: { transformPerspective: 1000, rotationY: 40, x: '-50%', z: -500, transformOrigin: 'right', opacity: 0 },
	  to: { transformPerspective: 1000, rotationY: 0, x: '0%', z: 0, transformOrigin: 'right', opacity: 1 }
	};
	
	var imageRight = exports.imageRight = {
	  from: { transformPerspective: 1000, rotationY: 40, x: '50%', z: -500, transformOrigin: 'left', opacity: 0 },
	  to: { transformPerspective: 1000, rotationY: 0, x: '0%', z: 0, transformOrigin: 'left', opacity: 1 }
	};
	
	var sgTopFade = exports.sgTopFade = {
	  from: { transformPerspective: 500, rotationX: 20, transformOrigin: "center top", opacity: 0, ease: Power2.easeOut },
	  to: { rotationX: 0, opacity: 1 }
	};

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2, _class2, _temp3;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(66);
	
	var _scrollmagic = __webpack_require__(23);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animations = __webpack_require__(89);
	
	var animations = _interopRequireWildcard(_animations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/no-find-dom-node */
	
	var AnimationScroll = (_temp2 = _class = function (_Component) {
	  _inherits(AnimationScroll, _Component);
	
	  function AnimationScroll() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimationScroll);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.animRefs = [], _this.scenes = [], _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AnimationScroll.prototype.componentWillMount = function componentWillMount() {
	    AnimationScroll.count++;
	    this.count = AnimationScroll.count;
	  };
	
	  AnimationScroll.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var duration = this.props.duration;
	
	    var types = this.props.types.replace(/ /g, '').split(',');
	
	    this.animRefs.forEach(function (ref, index) {
	      var node = (0, _reactDom.findDOMNode)(ref);
	      var delay = window.innerWidth < 640 ? 0 : _this2.props.delay;
	      var type = types[index] || types[types.length - 1];
	      var animation = TweenMax.fromTo(node, duration, animations[type].from, animations[type].to).pause().delay(delay * index);
	
	      var scene = new _scrollmagic.Scene({
	        triggerElement: node,
	        triggerHook: 0.6
	      });
	      var indicatorName = 'Scrollanimation ' + _this2.count + '.' + index;
	      scene.on('enter', function () {
	        return animation.play();
	      });
	
	      if (false) {
	        scene.addIndicators({ name: indicatorName });
	      }
	
	      scene.addTo(_this2.context.scrollmagic);
	      _this2.scenes.push(scene);
	    });
	  };
	
	  AnimationScroll.prototype.componentWillUnmount = function componentWillUnmount() {
	    AnimationScroll.count--;
	    this.scenes.forEach(function (scene) {
	      scene.destroy();
	    });
	  };
	
	  AnimationScroll.prototype.render = function render() {
	    return this.children;
	  };
	
	  _createClass(AnimationScroll, [{
	    key: 'children',
	    get: function get() {
	      var _this3 = this;
	
	      return _react.Children.map(this.props.children, function (child, key) {
	        return _react2.default.createElement(
	          RefWrapper,
	          { key: key, ref: function ref(c) {
	              _this3.animRefs.push(c);
	            } },
	          child
	        );
	      });
	    }
	  }]);
	
	  return AnimationScroll;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  duration: _propTypes2.default.number,
	  delay: _propTypes2.default.number,
	  types: _propTypes2.default.string
	}, _class.defaultProps = {
	  duration: 0.5,
	  delay: 0,
	  types: 'fadeIn'
	}, _class.contextTypes = {
	  scrollmagic: _propTypes2.default.any
	}, _class.count = 0, _temp2);
	exports.default = AnimationScroll;
	var RefWrapper = (_temp3 = _class2 = function (_Component2) {
	  _inherits(RefWrapper, _Component2);
	
	  function RefWrapper() {
	    _classCallCheck(this, RefWrapper);
	
	    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	  }
	
	  RefWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefWrapper;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.node
	}, _temp3);
	module.exports = exports['default'];

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(892);
	
	var _AnimationScroll = __webpack_require__(90);
	
	var _AnimationScroll2 = _interopRequireDefault(_AnimationScroll);
	
	var _gsap = __webpack_require__(39);
	
	var _Helmet = __webpack_require__(92);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var peopleData = [{
	  id: 1,
	  name: 'Kritika Jeff',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00325-edit.jpg',
	  des: 'is a designer who never works in half measures. An empty space drives her imagination crazy. Her sense of design comes from watching her father produce miracles as an architect. As Kritika says, art must be functional and spaces must speak. Travel, adventure and food are things that nourish her soul.'
	}, {
	  id: 2,
	  name: 'Sharannya K T',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00318-1.jpg',
	  des: 'is an independent spirit, believes in love, and its this emotion she tries to evoke in every space. A passionate architect whose love for design rivals that of her pets, her independent soul is complemented by her love for dance, yoga and the soul stirring notes of old music.'
	}, {
	  id: 3,
	  name: 'Meenhas F Naaz',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00290-edit-1.jpg',
	  des: 'is a dreamer, who thinks about interiors in terms of imagination and creativity yet not leaving logic behind. A quiet girl who lets her work do the talking, her passion is expressed in the beautiful lines of furniture, her resolve in taking her projects to their logical conclusion. '
	}, {
	  id: 5,
	  name: 'Mahesh Manohar',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00311-1.jpg',
	  des: 'comes to the team with more than 5 years of experience. He is constantly in an attempt to better his expertise, and his skills are equally matched by his wit. He enjoys long drives and gaming, and also spends his time in search of good food.'
	}, {
	  id: 6,
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00297-1.jpg',
	  name: 'Mradula Tiwari',
	  des: 'is the quirky member of the team and is fondly referred to as Maddy. She is bold in her choices, quick at what she does and always rises to any challenge that presents itself. When given the time, she uses it to catch up on the latest movies and shows, and is a big fan of anime.'
	}, {
	  id: 7,
	  name: 'Manpreet Bhattee',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00300.jpg',
	  des: 'is a recent graduate and spends his time developing designs for products and sketching them. A keen foodie, he is also the go to person to find out about good eateries in the locality. '
	}, {
	  id: 8,
	  name: 'Sheena Thomas',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00334-1.jpg',
	  des: 'is a member of a new generation of designers that combine shrewd analysis, playful experimentation and humour. Quick to learn, eager to know and with her own set of lovable quirks she is an integral part of the design team. As serious as she is about work, you can often find her unwinding and playing with strays or engrossed in a book.'
	}, {
	  id: 9,
	  name: 'Amit Verma',
	  src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00302.jpg',
	  des: 'is a designer and an engineer and is quick to figure out solutions to design dilemmas. He strongly believes in the power of research in design development and can quite often be found sketching at his table. '
	}];
	
	var AboutPage = function (_React$Component) {
	  _inherits(AboutPage, _React$Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.componentDidMount = function componentDidMount() {
	    var tm = new _gsap.TimelineLite({ paused: true });
	    tm.set(this.effectContainerHeroText, { opacity: 0 });
	    tm.to(this.effectContainerBgHero, 0.4, { width: '100%' }).to(this.effectContainerHeroText, 0.1, { opacity: 1 }).to(this.effectContainerBgHero, 0.8, { width: '0%', ease: Power4.easeInOut });
	
	    tm.play();
	  };
	
	  AboutPage.prototype.render = function render() {
	    var _this2 = this;
	
	    console.log('asdasd', this.props);
	    return _react2.default.createElement(
	      'main',
	      { className: 's', style: { paddingBottom: '7rem' } },
	      _react2.default.createElement(_Helmet2.default, {
	        title: 'About //// Studio Gritt',
	        description: 'Studio Gritt is a design universe, a place where our ideas are born, discussed, rejected, reborn and become real.',
	        image: 'https://studiogritt.files.wordpress.com/2018/04/dsc00277-1.jpg'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'about-main-hero' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container hero-container' },
	          _react2.default.createElement('div', { ref: function ref(e) {
	              return _this2.effectContainerBgHero = e;
	            }, className: 'container--over for-effect-gray' }),
	          _react2.default.createElement(
	            'h3',
	            { ref: function ref(e) {
	                return _this2.effectContainerHeroText = e;
	              }, style: { position: 'relative' } },
	            _react2.default.createElement('div', { className: 'text-bottom-underline' }),
	            'We are fuelled by the purpose of making your life easy'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimationScroll2.default,
	        { types: 'sgTopFade', duration: 1 },
	        _react2.default.createElement(
	          'div',
	          { className: 'about-main-hero', style: { padding: '100px 0 0' } },
	          _react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00499.jpg', style: { width: '100%' } })
	        )
	      ),
	      _react2.default.createElement(
	        _AnimationScroll2.default,
	        { types: 'sgTopFade' },
	        _react2.default.createElement(
	          'section',
	          { className: 'cs-section cs-about', style: { padding: '100px 0', backgroundColor: '#fff' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'cs-home-about--text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'h5',
	                { style: { width: '100%' } },
	                'Studio Gritt is our design universe, a place where our ideas are born, discussed, rejected, reborn and become real. It is a space where we work as a community, on a common floor, on common ground. Where life and form is infused into your furniture, spaces and products.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: "#fff" } },
	        _react2.default.createElement(
	          _AnimationScroll2.default,
	          { types: 'fadeIn', duration: 1.4 },
	          _react2.default.createElement(
	            'div',
	            { className: 'about-main-hero', style: { backgroundSize: 'cover', padding: '0px 0', backgroundColor: '#fff' } },
	            _react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00277-1.jpg', style: { width: '100%' } })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'cs-section cs-about', style: { marginTop: '150px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'group-image' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row', style: { alignItems: 'center' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-3' },
	                _react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/dsc00363-edit-1.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-md-offset-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'team-person--container' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Nithin Antony',
	                    _react2.default.createElement(
	                      'small',
	                      null,
	                      'DESIGN DIRECTOR'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    ' is a gardener of people. His understanding of them is deep and complete, nurturing them and their creativity, pushing them to challenge themselves and find their own voice. With an intuitive understanding of design, he brings a passionate energy to his work. When he isn\u2019t brainstorming new design concepts, he can be found feeding his team delicious grub, pulling them along on jungle safaris and treks, playing with Eva, his German Shepherd or spending time with family.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              peopleData.map(function (people) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row', style: { alignItems: 'center', marginTop: '100px' } },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-5', style: { marginBottom: '30px' } },
	                        _react2.default.createElement('img', { src: people.src })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'team-person--container' },
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            people.name
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            people.des
	                          )
	                        )
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: '' })
	    );
	  };
	
	  return AboutPage;
	}(_react2.default.Component);
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-d5eafa64ccc62df9f43f.js